import { Injectable } from '@angular/core';
import { PaymentComponentConfig } from '@src/app/core/models/ib-subscription-models-payment-model';
import { subscriptionModelsAppConstant } from '@src/ib-subscription-models-app-constants';

@Injectable({
    providedIn: 'root'
})
export class IbSubscriptionModelsPaymentWebComponentService {
    private paymentWebComponent = null;
    private readonly INDEX_URL = `${subscriptionModelsAppConstant.DEFAULT_ENDPOINTS.PAYMENT_COMPONENT_URI}index.esm.js`;
    private readonly COMPONENT_ESM = `${subscriptionModelsAppConstant.DEFAULT_ENDPOINTS.PAYMENT_COMPONENT_URI}payment-component.esm.js`;


    getNewPaymentComponent = async (componentConfig: PaymentComponentConfig) => {
        if (this.paymentWebComponent === null) {
            await this.importWebComponent();
        }
        await this.paymentWebComponent?.init(componentConfig);
        return this.paymentWebComponent;
    };

    private importWebComponent = async () => {
        const [PaymentComponentModule] = await Promise.all(
            [
                import(/* webpackIgnore: true*/ this.INDEX_URL),
                import(/* webpackIgnore: true*/ this.COMPONENT_ESM)
            ]
        );
        const {PaymentWebComponent} = PaymentComponentModule;
        this.paymentWebComponent = new PaymentWebComponent();
        return this.paymentWebComponent;
    };

}
